export const getBadgeProps = (source_application) => {
    if (source_application && source_application.toLowerCase().includes('rbfs')) {
        return { label: 'RBFS', backgroundColor: '#007bff', textColor: '#ffffff' };
    } else {
        return { label: 'MS2', backgroundColor: '#28a745', textColor: '#ffffff' };
    }
};

export const findBy = (node, type = "content") => {
    if (node && typeof node === "object") {
        for (const key in node) {
            if (key === type) {
                // Return the first key's value from the matched type node
                const nextNode = node[key];
                if (typeof nextNode === "object" && nextNode !== null) {
                    const mainNode = nextNode[Object.keys(nextNode)[0]]
                    return mainNode[Object.keys(mainNode)[0]];
                }
                return nextNode; // If the value isn't an object, return it directly
            }
            // Recursively search in child nodes
            const result = findBy(node[key], type);
            if (result !== null) return result;
        }
    }
    return null; // Return null if the type is not found
};


// Main function to convert flat paths to nested structure
export const convertToNestedStructure = (flatStructure, key="content") => {
    try {
        const content = findBy(flatStructure, key);
        if (!content) {
            console.warn(`"${key}" field is missing or invalid. Returning default structure.`);
            return {
                name: "",
                children: []
            };
        }
        return {
            name: "",
            children: traverse(content),
        };
    } catch (error) {
        console.error('Error in convertToNestedStructure:', error);
        return {
            name: "",
            children: []
        };
    }
};

function traverse(node) {
    try {
        if (Array.isArray(node)) {
            // Handle arrays (e.g., files or mixed arrays of files and folders)
            return node.map((item) => traverse(item)).flat();
        } else if (typeof node === 'object' && node !== null) {
            // Handle objects (directories)
            return Object.entries(node).map(([key, value]) => ({
                name: key,
                children: traverse(value) // Recursively process children
            }));
        } else if (typeof node === 'string') {
            // Handle string leaf nodes (files)
            return { name: node };
        }
        return []; // Return an empty array for unexpected input types
    } catch (error) {
        console.error('Error in traverse:', error);
        return [];
    }
}


export const searchTree = (tree, query) => {
    if (!query) return [tree]; // If no query, return the full tree wrapped in an array

    const filterTree = (node) => {
        // Check if the node's name includes the query string
        const isMatch = node.name.toLowerCase().includes(query.toLowerCase());

        // If the node has children, recursively filter them
        if (node.children && node.children.length > 0) {
            const filteredChildren = node.children
                .map(filterTree) // Recursively filter children
                .filter((child) => child !== null); // Remove nulls

            // If the node itself matches or has matching children, include it
            if (isMatch || filteredChildren.length > 0) {
                return { ...node, children: filteredChildren, isExpanded: true };
            }
        }

        // If the node is a leaf and matches, include it
        if (isMatch) {
            return { ...node };
        }

        // Otherwise, exclude the node
        return null;
    };

    // Filter the root node
    const filteredRoot = filterTree(tree);

    // Return the filtered root as an array (since the root is a single node)
    return filteredRoot ? [filteredRoot] : [];
};

export const findFilesByKey = (node, type = "archive", path = [], isUnderContent = false) => {
    let results = [];

    // Skip if we're under a content folder
    if (isUnderContent) {
        return results;
    }

    // Handle arrays
    if (Array.isArray(node)) {
        node.forEach(child => {
            results = results.concat(findFilesByKey(child, type, path, isUnderContent));
        });
    } 
    // Handle objects
    else if (typeof node === "object" && node !== null) {
        for (const key in node) {
            const newPath = [...path, key];
            
            // Check if we're entering a content section
            const checkingContent = key === "content";
            
            // Check if this is the archive key we're looking for
            if (key === type && !isUnderContent) {
                // Process archive array
                node[key].forEach(item => {
                    // Each item in archive array is an object with UUID as key
                    Object.entries(item).forEach(([uuid, files]) => {
                        // Add each file with its full path
                        files.forEach(file => {
                            results.push({
                                file,
                                uuid,
                                path: `${newPath.join("/")}/${uuid}/${file}`
                            });
                        });
                    });
                });
            }
            
            // Continue searching in nested objects/arrays
            // Pass the content flag if we're inside a content section
            results = results.concat(
                findFilesByKey(
                    node[key], 
                    type, 
                    newPath, 
                    isUnderContent || checkingContent
                )
            );
        }
    }
    
    return results;
};

export const getTokenByAppName = (location) => {
    const segments = location.replace(/^\/+/, "").split("/");
    const appName = segments[0].toUpperCase();
    if(appName === "RBFS") {
        return process.env.REACT_APP_RBFS_SAS_TOKEN;
    } else if(appName === "MS2") {
        return process.env.REACT_APP_MS2_SAS_TOKEN;
    }
    return null
}